import React from 'react';
import classNames from "./RecordingsView.module.css";
import ccss from '../../Styles/common.module.css';
import { observer } from 'mobx-react-lite';
import { DbRecordingEntryWriter } from '../../State/EvidenceDB/DbRecordingEntryWriter';
import { friendlyTimeSince } from '../../lib/utils/friendlyTimeSince';
import { isISODateTimeString } from '../../State/EvidenceDB/DatabaseTypes';
import { DbRecordingsTableWriter } from '../../State/EvidenceDB/DbRecordingsTableWriter';
import { DbRecordingsTableCached } from '../../State/EvidenceDB/DbRecordingsTableCached';
import { WindowRoutingStateContext } from './WindowRoutingState';


export const RecordingRowView = observer( ({recordingWriter}:
	{recordingWriter: DbRecordingEntryWriter}
) => {
	const windowRoutingState = React.useContext(WindowRoutingStateContext);
	const {recording} = recordingWriter;
	if (recording == null) return null;
	const {dataSummary, status, stopTimeIso, startTimeIso} = recording;

	let websitesListAsString = dataSummary?.sourcePageRegisteredDomains
		?.toSorted( (a, b) => b.numberOfRequests - a.numberOfRequests)
		?.map( ({registeredDomain}) => registeredDomain )
		?.join(", ") ?? "";	
	if (websitesListAsString.length >= 40) {
		websitesListAsString = websitesListAsString.slice(0, 39) + "…";
	}
	
	const stopIso = dataSummary?.whenLastObservedIso ?? stopTimeIso;
	const startIso = dataSummary?.whenFirstObservedIso ?? startTimeIso;
	const finishedAt = isISODateTimeString(stopIso) ? friendlyTimeSince(stopIso) :
		status === 'stopped' || status === 'archived' ? (<i>unknown</i>) :
		(<i>in progress</i>)
	const durationInSeconds = !isISODateTimeString(startIso) || !isISODateTimeString(stopIso) ? undefined :
		Math.round( (new Date(stopIso).getTime() - new Date(startIso).getTime()) / 1000);
	const durationString = durationInSeconds == null ? undefined : 
		durationInSeconds < 3600 ?
		`${Math.floor(durationInSeconds / 60).toLocaleString('en', {minimumIntegerDigits: 2})
			}:${(durationInSeconds % 60).toLocaleString('en', {minimumIntegerDigits: 2})}` :
		`${Math.floor(durationInSeconds / 3600)}:${Math.floor((durationInSeconds % 3600) / 60)}:${(durationInSeconds % 60).toLocaleString('en', {minimumIntegerDigits: 2})}`;
	
  const deleteRecording = (dbRecordingEntryWriter: DbRecordingEntryWriter) => async (event: React.MouseEvent) => {
		event.stopPropagation();
		if (window.confirm(`Delete recording ${dbRecordingEntryWriter.nameOrDescription}?`)) {
			await DbRecordingsTableWriter.deleteRecording(recording.recordingUuid);
		}
	}

	return (
		<tr key={recording.recordingUuid} onClick={ () => windowRoutingState?.pushPath(`/recordings/${recording.recordingUuid}`) } >
			{/* FIXME -- need to preserve cursor on change, see https://stackoverflow.com/questions/46000544/react-controlled-input-cursor-jumps */}
			<td>{ // <input type="text" defaultValue={recordingWriter.name} placeholder={recordingWriter.placeholderName} onChange={updateName({recordingWriter})} />
				recordingWriter.name ?? (<i>unnamed</i>)
			}</td>
			<td>{websitesListAsString}</td>
			<td>{finishedAt}</td>
			<td>{durationString}</td>
			<td>{dataSummary?.numberOfRequests}</td>
			<td><button className={[ccss.borderless, ccss.redOnHover].join(' ')} onClick={deleteRecording(recordingWriter)}>✗</button></td>
		</tr>
		)
	});


export const RecordingsView = observer ( () => {
	const recordingsTableCached = DbRecordingsTableCached.instance;
	if (recordingsTableCached == null) return (<div>Loading...</div>);
	const recordingWriters = recordingsTableCached.recordingWritersNewestToOldest;
	return (
		<div className={classNames.RecordingsPageContainer}>
			<div className={classNames.TableContainerElement}>
				<h2>Recordings</h2>
				<table className={classNames.RecordingsTableElement}>
					<thead>
						<tr>
							<th>Name</th>
							<th>Website(s)</th>
							<th>Finished</th>
							<th>Duration</th>
							<th>Requests</th>
							<th></th>
						</tr>
					</thead>
					{/* <div>{ JSON.stringify(recordingWriters) }</div> */}
					<tbody>
					{
						recordingWriters.map( (recordingWriter) => (<RecordingRowView key={recordingWriter.recordingUuid} {...{recordingWriter}} />) )
					}
				</tbody>
				</table>
			</div>
		</div>
	);
});
